/**
 * TrustLogosBlock — trust-mark logos под списком тарифов.
 *
 * Figma source: `319:4659` (frame `secure`, 370×46).
 *   logo (90×30)  — PCI Security Standards
 *   logo (108×30) — Secure Payments / Powered by Stripe
 *   logo (64×28)  — Verified by VISA
 *
 * SVG-ассеты экспортированы из Figma plugin runtime и лежат под
 *   /icons/payment/trust/{logo.svg,logo-1.svg,logo-2.svg}.
 *
 * Внутри SVG fill жёстко прописан #464646 (тёмно-серый — значение из
 * Figma source). Per design review цвет логотипов ДОЛЖЕН быть #464646 —
 * никакой пост-обработки тона. Filter удалён, ассеты рендерятся 1:1.
 */
import { useTranslation } from 'react-i18next';

const LOGOS = [
  { key: 'pci',      file: 'logo.svg',   w: 90,  h: 30, alt: 'PCI Security Standards' },
  { key: 'stripe',   file: 'logo-1.svg', w: 108, h: 30, alt: 'Secure Payments — Powered by Stripe' },
  { key: 'verified', file: 'logo-2.svg', w: 64,  h: 28, alt: 'Verified by VISA' },
];

export default function TrustLogosBlock({ className = '' }) {
  const { t } = useTranslation();
  return (
    <div
      className={[
        'flex items-center justify-center gap-8 py-2',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={t('plans.securePayment', 'Secure payment')}
    >
      {LOGOS.map((logo) => (
        <img
          key={logo.key}
          src={`/icons/payment/trust/${logo.file}`}
          alt={logo.alt}
          width={logo.w}
          height={logo.h}
          className="shrink-0 select-none"
          data-testid={`trust-logo-${logo.key}`}
        />
      ))}
    </div>
  );
}
